module.exports = __webpack_public_path__ + "img/6.fed388bd.svg";